import React from 'react';
export const RouteLoader = (props) => {
    const { message = 'Loading section...' } = props;
    return (React.createElement("div", null,
        React.createElement("h4", { className: "section-label" },
            React.createElement("i", { className: "fas fa-spinner fa-spin" }),
            " ",
            message)));
};
